import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledBackButton = styled.div`
	position: absolute;
	top: 80px;
	left: 80px;
	display: flex;
	align-items: center;
	gap: 10px;
	height: 40px;
	padding: 0 15px;
	cursor: pointer;
	background: #111314;
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	transition: background 0.3s ease;

	&:hover {
		background: #ffffff;

		${Text} {
			color: #000000;
		}

		img {
			filter: invert(100%);
		}
	}

	img {
		width: 8px;
		height: 12px;
		margin: 0 -1.5px;
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}

	${Text} {
		font-weight: 500;
		font-size: 16px;
		color: #ffffff;
		transition: color 0.3s ease;
	}
`;

const StyledTitle = styled.div`
	position: absolute;
	top: 80px;
	left: 50%;
	transform: translateX(-50%);
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;
	height: 40px;
	padding: 0 10px;
	background: #1782ff;
	border-radius: 10px;

	${Text} {
		font-weight: 500;
		font-size: 16px;
		color: #ffffff;
	}
`;

export { StyledBackButton, StyledTitle };
